const sortText = (a, b, field) => {
  if (a !== null && a[field] !== null && b !== null && b[field] !== null && field !== null) {
    if (a[field] < b[field]) return -1
    if (a[field] > b[field]) return 1
  }
  return 0
}

export default sortText
